export default "<!--<app-horloge-numerique *ngIf=\"date\" [date]=\"date\"></app-horloge-numerique>-->\r\n";